module.exports = __webpack_public_path__ + "img/arrow-left-black.84c5f975.png";